import { Component, OnInit, Input } from '@angular/core';
import { Location } from '@angular/common';
import { UtilityServiceService } from 'projects/services/src/app/API/utility-service.service';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { ShareDataService } from 'projects/shared/src/app/shared/share-data.service';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { ActivatedRoute } from '@angular/router';
declare const swal: any;

@Component({
  selector: 'app-candidate-feedback',
  templateUrl: './candidate-feedback.component.html',
  styleUrls: ['./candidate-feedback.component.css']
})
export class CandidateFeedbackComponent implements OnInit {
  @Input() batchDetails: any;
  @Input() candidatId: any;

  feedbackForm: FormGroup
  candidateFeedbackForm: FormGroup
  questions: any = [];
  loggedInUserName: any;
  role: any;
  isUpdate: boolean;
  feedbackType: any;
  showLabel: boolean;
  hideForm: boolean;
  constructor(
    private location: Location,
    private utilityService: UtilityServiceService,
    private fb: FormBuilder,
    private currentUserService: CurrentUserService,
    private sharedService: ShareDataService,
    private router: ActivatedRoute,
  ) {
    this.candidateFeedbackForm = this.fb.group({
			feedbacks: fb.array([])
    });

    this.currentUserService.getCurrentUser().subscribe(res => {
      this.loggedInUserName = res && res.userName;
      this.role = res && res.role;
    })


    if (this.role === 'Training Partner' ) {
      this.sharedService.getCandidateId().subscribe(res => {
        this.candidatId = res;
      })
    }
  }

  get candidate(): FormArray {
		return this.candidateFeedbackForm.get('feedbacks') as FormArray;
  }


  displayQuestion(qId,question) {
    if (qId === 'Q1') {
      const tpName = this.batchDetails && this.batchDetails.tpName || ''
      let replacedString = question.replace("[TP Name]", `"${tpName}"`);
      return replacedString
    } else if (qId === 'Q2') {
      const sector = this.batchDetails && this.batchDetails.sector && this.batchDetails.sector.name || ''
      let replacedString = question.replace("[Sector]", `"${sector}"`);
      return replacedString
    } else if (qId === 'Q3') {
      const jobRoleId = this.batchDetails && this.batchDetails.jobRoles && this.batchDetails.jobRoles[0] && this.batchDetails.jobRoles[0].qpCode || ''
      let replacedString = question.replace("[Job Role ID]", `"${jobRoleId}"`);
      const jbName = this.batchDetails && this.batchDetails.jobRoles && this.batchDetails.jobRoles[0] && this.batchDetails.jobRoles[0].jobName || ''
      let replaceFinalString = replacedString.replace("[Job Role Name]", `"${jbName}"`)
      return replaceFinalString
    }  else if (qId === 'Q4') {
      const candidateList = this.batchDetails && this.batchDetails.candidates || [];
      // for (let index = 0; index < candidateList.length; index++) {
      //   if (this.loggedInUserName === candidateList[index].userName) {
          const appliedOn = Helpers.formatDateToView(this.batchDetails.candidates.appliedOn)
          let replacedString = question.replace("[Date of enrolment]", `"${appliedOn}"`);
          return replacedString
      //   }
      // }
    }
    else {
      return question
    }
  }

  createCandidateFeedbackForm(data) {
		return this.fb.group({
      feedback: this.fb.group({
        id: [data.id],
				question: [data.questionString],
        choice: [null,[Validators.required]],
			})
		});
	}
  ngOnInit() {
    this.sharedService.getFeedbackType().subscribe(type => {
      this.feedbackType = type;
    })
    this.sharedService.getFeedbackHistory().subscribe(id => {
      this.historyId = id;
    })
    this.feedbackForm = this.fb.group({
      feedback: this.fb.array([])
    })
    console.log(this.batchDetails)
    if (this.role === 'Continuous Monitoring' || this.role === 'Fee Based DA') {
      this.router.params.subscribe(params => {
        this.loggedInUserName = params.canId;
        this.getQuestionsForCandidate();
      });      // this.loggedInUserName = this.batchDetails && this.batchDetails.candidates && this.batchDetails.candidates.candidateId
    } else {
      this.getQuestionsForCandidate();

    }

  }

  getFeedback() {
    if (this.feedbackType === 'history') {
      if (this.role === 'Candidate') {
        this.utilityService.getFeedbackHistoryById(this.historyId).subscribe(res => {
          const feedbackData = res && res.data && res.data.d && res.data.d.feedback;
          if (feedbackData) {
            this.isUpdate = true;
          }
          for (let index = 0; index < feedbackData.length; index++) {
            if (feedbackData[index].answer === null) {
              this.candidateFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').disable()
              this.candidateFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').setValidators([])
              this.candidateFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').updateValueAndValidity();
            }
            this.candidateFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').patchValue(feedbackData[index].answer);

          }
        })
      } else if (this.role === 'Training Partner') {
        this.utilityService.getFeedbackData(this.batchDetails.batchId, this.candidatId, 'CEG').subscribe(res => {
          const feedbackData = res && res.data && res.data.d && res.data.d.feedback || [];

          for (let index = 0; index < feedbackData.length; index++) {
            this.candidateFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').patchValue(feedbackData[index].answer);
            this.candidateFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').disable()

          }
        })
      }

    } else {
      if (this.role === 'Candidate') {
        this.utilityService.getFeedbackData(this.batchDetails.batchId, this.loggedInUserName, 'CEG').subscribe(res => {
          const feedbackData = res && res.data && res.data.feedback || [];
          if (feedbackData.length > 0) {
            this.isUpdate = true;
          }
          for (let index = 0; index < feedbackData.length; index++) {
            if (feedbackData[index].answer === null) {
              this.candidateFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').disable()
              this.candidateFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').setValidators([])
              this.candidateFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').updateValueAndValidity();
            }
            this.candidateFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').patchValue(feedbackData[index].answer);

          }
        })
      } else if (this.role === 'Training Partner') {
        this.utilityService.getFeedbackData(this.batchDetails.batchId, this.candidatId, 'CEG').subscribe(res => {
          const feedbackData = res && res.data && res.data.feedback || [];
          if (feedbackData.length === 0) {
            this.hideForm = true;
            this.showLabel = true;
          }
          for (let index = 0; index < feedbackData.length; index++) {
            this.candidateFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').patchValue(feedbackData[index].answer);
            this.candidateFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').disable()

          }
        })
      } else if (this.role === 'Continuous Monitoring' || this.role === 'Fee Based DA') {
        this.utilityService.getFeedbackData(this.batchDetails.batchId, this.loggedInUserName, 'CEG').subscribe(res => {
          const feedbackData = res && res.data && res.data.feedback || [];
          if (feedbackData.length === 0) {
            this.hideForm = true;
            this.showLabel = true;
          }
          for (let index = 0; index < feedbackData.length; index++) {
            this.candidateFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').patchValue(feedbackData[index].answer);
            this.candidateFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').disable()
          }
        })
      }

    }

  }


  createFeedbackForm(data): FormGroup {
    return this.fb.group({
      questions: data.questionString,
      answer: [],
    })
  }


  getQuestionsForCandidate() {
    this.utilityService.getMasterQuestion('CEG').subscribe(res => {
      this.questions = res && res.data || [];
      console.log(this.questions)
      for (let index = 0; index < this.questions.length; index++) {
        // formInstance.push(this.createFeedbackForm(this.questions[index]))
        this.candidate.push(this.createCandidateFeedbackForm(this.questions[index]));
        this.getFeedback();
      }
    })
  }

  historyId(historyId: any) {
    throw new Error("Method not implemented.");
  }

  sumitFeedback() {
    if (this.isUpdate) {
      swal({
        title: 'Are You Sure, You want to Update?',
        type: 'info',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        cancelButtonColor: '#d33',
      }).then((action: any) => {
        if (action.value) {
          this.utilityService.updateFeedback(this.batchDetails.batchId, this.loggedInUserName,'CEG',this.mapPayload()).subscribe(res => {
            swal('Feedback Successfully Update');

          })
        }
      })
    } else {
      swal({
        title: 'Are You Sure, You want to submit?',
        type: 'info',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        cancelButtonColor: '#d33',
      }).then((action: any) => {
        if (action.value) {
          this.utilityService.addFeedback(this.mapPayload()).subscribe(res => {
            swal('Feedback Successfully Submitted');
            if (this.batchDetails.stage === 'enrollment' || this.batchDetails.stage === 'attendance') {
              this.goBack();
            } else {
              this.getFeedback();
            }
            // this.goBack();
          })
        }
      })
  }

  }

  mapPayload() {
    const elements = (this.candidateFeedbackForm.getRawValue().feedbacks) || [];
    const mapElements = elements.map(element => ({
      question: element && element.feedback && element.feedback.question,
      answer: element && element.feedback &&  element.feedback.choice
    }))
    const DATA = {
      tpName: this.batchDetails && this.batchDetails.tpName || '',
      tcName: this.batchDetails && this.batchDetails.tcName || '',
      sector: this.batchDetails && this.batchDetails.sector && this.batchDetails.sector.name || 'N/A',
      tpId: this.batchDetails && this.batchDetails.tpId || '',
      tcId: this.batchDetails && this.batchDetails.tcId || '',
      jobName: this.batchDetails && this.batchDetails.jobRoles && this.batchDetails.jobRoles[0] && this.batchDetails.jobRoles[0].jobName || '',
      qpCode: this.batchDetails && this.batchDetails.jobRoles && this.batchDetails.jobRoles[0] && this.batchDetails.jobRoles[0].qpCode || '',
      jobRoleDesc: this.batchDetails && this.batchDetails.jobRoles && this.batchDetails.jobRoles[0] && this.batchDetails.jobRoles[0].jobRoleDesc || '',
      batchId: this.batchDetails && this.batchDetails.batchId,
      createdBy: this.loggedInUserName,
      appliedOn: Helpers.formatDateToView(this.batchDetails && this.batchDetails.candidates && this.batchDetails.candidates.appliedOn),
      type: 'CEG',
      feedback: mapElements
    }
    console.log(DATA)
    return DATA
  }

  goBack() {
    this.location.back()

  }
  check(i) {
    const selectedChoice = this.candidateFeedbackForm.get('feedbacks')['controls'][i].get('feedback').value
    if (selectedChoice && selectedChoice.id === 'Q1') {
      if (selectedChoice.choice === false || selectedChoice.choice === 'false') {
        for (let index = 1; index < this.candidateFeedbackForm.get('feedbacks')['controls'].length; index++) {
          this.candidateFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').disable()
          this.candidateFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').reset()
          this.candidateFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').setValidators([])
          this.candidateFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').updateValueAndValidity()
        }
      } else {
        for (let index = 1; index < this.candidateFeedbackForm.get('feedbacks')['controls'].length; index++) {
          this.candidateFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').enable()
          this.candidateFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').setValidators([Validators.required])
          this.candidateFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').updateValueAndValidity()
        }
      }
    }

  }

  reset() {
    this.candidateFeedbackForm.reset();
  }
}
